import { createStore } from "effector";
import { getUserListFx } from "./effects"; // Add this import
import { addUserToListEv } from "./events"; // Add this import
import { formatUserListTable } from "./utils"; // Add this import

export const $userList = createStore([]).on(
  getUserListFx.doneData,
  (_, result) => {
    // Make sure we're accessing the userList property
    return formatUserListTable(result?.userList || []);
  }
);

export const $departmentsList = createStore([]).on(
  getUserListFx.doneData,
  (_, result) => result?.placeIdentifiers || []
);

$userList.watch((state) => {
  console.log("Current user list state:", state);
});

// Helper function to format new user consistently
const formatUser = (user) => ({
  ...user,
  key: `user-list-user-${user.partition_key || Date.now()}`,
  emp_category: user.emp_category || "Сотрудник",
  presigned_url: user.presigned_url || "/default_user_image.png",
});

export const $userListPlaceId = createStore("amaa25d7c9");
$userListPlaceId.watch((state) => console.log("$userListPlaceId", state));
export const $chosenUser = createStore(null);
$chosenUser.watch((state) => console.log("$chosenUser", state));

export const $potentialEmp = createStore(null);
$potentialEmp.watch((state) => console.log("$potentialEmp", state));

export const $showCreateModal = createStore(false);
$showCreateModal.watch((state) => console.log("$showCreateModal", state));

export const $chosenPotentialEmp = createStore(null);
$chosenPotentialEmp.watch((state) => console.log("$chosenPotentialEmp", state));

export const $chosenEmpImgModal = createStore(null);

export const $userListEdu = createStore([]);
$userListEdu.watch((state) => console.log("$userListEdu", state));

export const $userEmpCategory = createStore("Сотрудник");

export const $importFileModal = createStore(false);

export const $importFilesErrors = createStore([]);

export const $potentialEmpEdu = createStore([]);
$potentialEmpEdu.watch((state) => console.log("$potentialEmpEdu", state));

export const $chosenPotentialEmpEdu = createStore(null);

export const $chosenEmpEduImgModal = createStore(null);

export const $chosenViewEdu = createStore(null);

export const $editUserEdu = createStore(null);
